// src/components/BarChart.js

import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const BarChart = ({setConsumo}) => {

    const energiaResidual = 0.50; 

    const [dataValues, setDataValues] = useState([22, 15, 8, 13, energiaResidual]); // Valores de consumo

    const updateData = () => {
        
        fetch('#{TourDomain}#/tour360/api2.php')
        .then(response => response.json())
        .then(data => {
            // Calculamos el nuevo valor

            const newValue = parseFloat(data.total) + energiaResidual;

            const newValueLimit = Number(newValue).toFixed(3);
            
            // Copiamos los valores anteriores y reemplazamos el último valor con el nuevo valor
            const newDataValues = [...dataValues.slice(0, -1), newValueLimit];
            setDataValues(newDataValues); 

            setConsumo(newValueLimit);
        }); 


    };

    useEffect(() => {
        // Configuramos un intervalo para actualizar los datos cada 5 segundos
        const interval = setInterval(() => {
        updateData();
        }, 3000); // 3000 milisegundos = 3 segundos

        // Devolvemos una función de limpieza para detener el intervalo cuando el componente se desmonte
        return () => clearInterval(interval);
    }, [dataValues]);

    const data = {
        labels: ['8', '9', '10', '11', '12'],
        datasets: [
        {
            label: 'Wh',
            data: dataValues,
            backgroundColor: ['#FF7705', '#FF7705', '#FF7705', '#FF7705', '#FF7705'],
        },
        ],
    };

  
    const options = { 
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Wh',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Hora',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
        },
        plugins: {
            title: {
              display: false, // Establece display en false para ocultar el título
            },
            legend: {
                display: false, // Oculta la leyenda
            }, 
        },
    };
  
    // Estilos CSS para el contenedor del gráfico
    const containerStyles = {
        backgroundColor: 'white',
        width: '100%', // Cambia el ancho a 100%
        height: '350px',
        
    };
  
    return (
        <Bar data={data} options={options} width={'100%'} height={'100%'}/>
    );
  };
  
  export default BarChart;